/**
 * Константы ID для пунктов быстрого меню
 */
export const QUICK_ACTION_IDS = {
  WISHLIST: 'wishlist',
  WISH: 'wish',
  FRIEND: 'friend',
  SECRET_SANTA: 'secret-santa',
} as const;